const Dock = {
  symbol: 'dock',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm-.069-21.229v-.004A8 8 0 1 0 23 18.87l-.001-.067V6.142a1.143 1.143 0 0 0-2.286 0v12.576a5.695 5.695 0 1 1-4.705-5.63l-1.707 1.707a1.143 1.143 0 0 0 1.616 1.616l3.64-3.636a1.143 1.143 0 0 0 0-1.617l-3.636-3.636-.038-.038a1.144 1.144 0 1 0-1.582 1.654l1.63 1.633z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#786DBC"/><path d="M15.931 10.771l-1.629-1.633a1.144 1.144 0 0 1 1.582-1.654l.038.038 3.636 3.636c.447.447.447 1.17 0 1.617l-3.64 3.636a1.143 1.143 0 0 1-1.616-1.616l1.707-1.707a5.695 5.695 0 1 0 4.705 5.63V6.142a1.143 1.143 0 0 1 2.286 0v12.729a8 8 0 1 1-7.07-8.104l.001.004z" fill="#FFF"/></g>`;
  }
};
export default Dock;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/dock.js
// module id = null
// module chunks = 